module.exports = __webpack_public_path__ + "img/favicon.fb1f1445.png";